import './details/details';
import './details/details-package';
import './details/details-accommodation';
import './details/details-travel';